export default function formatter(value) {
  const safeNumber = parseFloat(value);
  const num = safeNumber.toFixed(0).replace(/./g, (c, i, a) => {
    return i && c !== '.' && ((a.length - i) % 3 === 0) ? `,${c}` : c;
  });
  return num;
}
